import Auth from "./auth";
import Login from "./login";

const SessionRoutes = { Auth, Login };

export default SessionRoutes;
